module.exports = __webpack_public_path__ + "img/logo.55f4ed64.png";